import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import inventoryApi from '../../../services/inventoryApi';;

const SalesRefList = () => {
  const navigate = useNavigate();
  const [salesRefs, setSalesRefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [view, setView] = useState(() => {
    try {
      return localStorage.getItem('salesRefManagementView') || 'card';
    } catch (error) {
      return 'card';
    }
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const salesRefStatuses = [
    { value: 'all', label: 'All Statuses' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' }
  ];

  const handleViewChange = (newView) => {
    setView(newView);
    try {
      localStorage.setItem('salesRefManagementView', newView);
    } catch (error) {
      console.warn('Failed to save view preference');
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleCreateSalesRef = () => {
    console.log('Create Sales Reference clicked - Form coming soon');
  };

  return (
    <div>
      <div className="w-full">
        <div className="bg-white shadow-sm border border-gray-200">
          <div className="px-4 sm:px-6 lg:px-8 py-2 border-b border-gray-200 flex-shrink-0 bg-gray-50">
            <div className="flex flex-col lg:flex-row lg:items-center gap-2">
              <div className="flex-1">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search sales references..."
                    value={searchTerm}
                    onChange={handleSearch}
                    className="block w-full pl-10 pr-3 py-1.5 text-sm bg-white border border-gray-300 shadow-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
                <select
                  value={statusFilter}
                  onChange={handleStatusFilter}
                  className="text-sm border border-gray-300 rounded-sm bg-white px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 min-w-[140px]"
                >
                  {salesRefStatuses.map(status => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
                <div className="flex bg-gray-100 rounded-md border border-gray-200 p-0.5">
                  <button
                    onClick={() => handleViewChange('card')}
                    className={`px-2 py-1 text-xs font-medium rounded transition-all ${view === 'card'
                      ? 'bg-white text-green-700 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                      }`}
                  >
                    <svg className="w-3 h-3 mr-1 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14-7H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2z" />
                    </svg>
                    Cards
                  </button>
                  <button
                    onClick={() => handleViewChange('list')}
                    className={`px-2 py-1 text-xs font-medium rounded transition-all ${view === 'list'
                      ? 'bg-white text-green-700 shadow-sm'
                      : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                      }`}
                  >
                    <svg className="w-3 h-3 mr-1 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                    </svg>
                    List
                  </button>
                </div>
                <button
                  onClick={handleCreateSalesRef}
                  className="inline-flex items-center px-3 py-1.5 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white text-sm font-medium rounded-md shadow-sm transition-all duration-200"
                >
                  <svg className="w-3.5 h-3.5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add Sales Reference
                </button>
              </div>
            </div>
          </div>
          <div className="p-2">
            <div className="text-center py-12">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">Sales References</h3>
              <p className="mt-1 text-sm text-gray-500">
                Sales reference management coming soon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesRefList;